import { render, staticRenderFns } from "./shoppingGuideTask_editor.vue?vue&type=template&id=3bbd8696&scoped=true"
import script from "./shoppingGuideTask_editor.vue?vue&type=script&lang=js"
export * from "./shoppingGuideTask_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd8696",
  null
  
)

export default component.exports